import React, { memo } from "react";
import { Breadcrumbs, Header, Workspace } from "components/Shared";
import Collection from "./Collection";

const Projects = ({ history }: any) => {
	return (
		<React.Fragment>
			<Breadcrumbs items={[{ title: "projects" }]} />
			<Header
				title="projects"
				toolbar={[{ onClick: () => history.push("/projects/new"), label: "new_project", icon: "new" }]}
			/>
			<Workspace id="projects" className="list">
				<Collection />
			</Workspace>
		</React.Fragment>
	);
};

const MemoizedProjects = memo(Projects);
export default ({ history }: any) => <MemoizedProjects history={history} />;
